import {type AxiosResponse} from "axios";
import {get, post} from "../../../infrastructure/api";
import {type ConfigurationResponseDto, type UserGroupDto, type UserTypeDto} from "../types";
import {AddEndpoint} from "./endpoints";
import {type ApiResponse} from "../../../infrastructure/types";

export const add = async (
  data: FormData
): Promise<AxiosResponse<ApiResponse<ConfigurationResponseDto>>> =>
  await post({endpoint: AddEndpoint.createConfiguration, data});

export const getUserTypes = async (): Promise<AxiosResponse<ApiResponse<UserTypeDto[]>>> =>
  await get({endpoint: AddEndpoint.userTypes});

export const getUserGroups = async (): Promise<AxiosResponse<ApiResponse<UserGroupDto[]>>> =>
  await get({endpoint: AddEndpoint.userGroups});
